import * as XLSX from "xlsx";

interface IExcelExport {
  headers: string[];
  data: Record<string, any>[];
  title?: string;
}

export const exportExcel = ({ headers, data, title }: IExcelExport) => {
  const worksheetData = [
    headers,
    ...data.map((row) => headers.map((header) => row[header] ?? "")),
  ];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Export");
  const safeTitle = title ? title.replace(/\s+/g, "_") : "export";
  const fileName = `${safeTitle}.xlsx`;

  XLSX.writeFile(workbook, fileName);
};
